import { createElementBlock as c, openBlock as a, createElementVNode as l } from "vue";
import o from "./index289.js";
const t = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function r(s, e, f, i, p, m) {
  return a(), c("svg", n, e[0] || (e[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "#FFF9D5",
        d: "M30.946 18.053C31.454 13.53 35.255 10 39.922 10c0 5.005 4.065 9.062 9.078 9.062 0 3.03-1.505 5.698-3.794 7.341L35 26.5l-4.054-8.447Z"
      }),
      l("path", {
        fill: "#F7F6EF",
        d: "M38.711 24.16c-1.17 0-2.269.234-3.231.7-.722-4.604-4.85-8.139-9.8-8.139-5.398 0-9.8 4.202-9.937 9.407-3.234.399-5.743 3.067-5.743 6.37 0 3.534 2.957 6.404 6.602 6.404h22.11c4.195 0 7.598-3.303 7.598-7.372 0-4.07-3.403-7.37-7.599-7.37Z"
      }),
      l("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M39.922 8.75c.69 0 1.25.56 1.25 1.25 0 4.314 3.505 7.812 7.828 7.812.69 0 1.25.56 1.25 1.25 0 3.188-1.474 6.127-3.93 8.066a8.408 8.408 0 0 1 1.24 4.402c0 4.768-3.971 8.622-8.849 8.622H16.602c-4.326 0-7.852-3.42-7.852-7.654 0-3.479 2.341-6.42 5.607-7.36l.212-.057.014-.113c.7-5.272 5.27-9.354 10.805-9.493l.292-.004c1.528 0 2.993.302 4.33.85 1.205-4.395 5.203-7.571 9.912-7.571ZM25.68 17.971c-4.715 0-8.568 3.657-8.687 8.19a1.25 1.25 0 0 1-1.097 1.207c-2.657.328-4.646 2.507-4.646 5.13 0 2.836 2.39 5.154 5.352 5.154h22.11c3.513 0 6.348-2.752 6.348-6.122s-2.835-6.12-6.349-6.12c-.993 0-1.905.196-2.687.575a1.25 1.25 0 0 1-1.78-.932c-.632-4.033-4.269-7.082-8.564-7.082Zm13.079-6.634-.082.012a7.795 7.795 0 0 0-6.395 6.227c1.876 1.338 3.312 3.231 4.038 5.448l.056.181.19-.05a9.088 9.088 0 0 1 1.776-.238l.37-.007a8.95 8.95 0 0 1 6.01 2.294l-.245.184a7.802 7.802 0 0 0 3.14-4.892l.045-.271-.063-.007c-4.582-.621-8.21-4.243-8.832-8.819l-.008-.062ZM16.447 44.392a1.25 1.25 0 0 1 2.287 1l-.051.118-2.018 4.033a1.25 1.25 0 0 1-2.287-1.001l.051-.118 2.018-4.032Zm16.138 0a1.25 1.25 0 0 1 2.287 1l-.051.118-2.018 4.033a1.25 1.25 0 0 1-2.287-1.001l.051-.118 2.018-4.032Zm-8.07 2.016a1.25 1.25 0 0 1 2.288 1.001l-.051.117-2.018 4.033a1.25 1.25 0 0 1-2.287-1.001l.051-.117 2.018-4.033Zm15.13 0a1.25 1.25 0 0 1 2.287 1.001l-.051.117-1.009 2.017a1.25 1.25 0 0 1-2.287-1.001l.051-.118 1.009-2.016Z"
      })
    ], -1)
  ]));
}
const _ = /* @__PURE__ */ o(t, [["render", r]]);
export {
  _ as default
};
